import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Avatar, AvatarContainer } from "./AvatarFace.styled";
const AvatarFace = React.memo((props) => {
    const { avatar, inline, ...avatarProps } = props;
    let avatarUrl = avatar?.avatar?.snapshots?.face256;
    if (avatarUrl && !avatarUrl.startsWith("https://")) {
        avatarUrl = `https://peer.decentraland.org/content/contents/${avatarUrl}`;
    }
    return (_jsx(AvatarContainer, { inline: inline, children: _jsx(Avatar, { src: avatarUrl, ...avatarProps }) }));
});
export { AvatarFace };
//# sourceMappingURL=AvatarFace.js.map